import { Metadata } from 'next'

const metadata: Metadata = {
  title: 'Become a ShipSticks Affiliate',
  description:
    'Partner with us to earn money offering premium, hassle-free shipping. ' +
    "It's easy to implement, free to join, and backed by support.",
  alternates: {
    canonical: 'https://www.shipsticks.com/affiliate',
  },
}

export default metadata
